import React, { useCallback, useEffect } from "react";

import { ChangesHeader } from "./component/header/ChangesHeader";
import { ChangesBody } from "./component/body/ChangesBody";

import { ChangeToColorMappingType } from "./types";

export interface ChangesStateProps {
    enabled: boolean;
    viewType: string;
    context: string;
    workspaceName?: string;
    generated?: string;
    effectiveDate: string;
    selectedChangeTypes?: string[];
    displayLoading?: boolean;
    isCesium?: boolean;
    changeTypeColoring?: ChangeToColorMappingType;
    ticket?: string;
    axiosInitialized?: boolean;
    slotsIds?: string | string[];
}

export interface ChangesDispatchProps {
    handleViewTypeChanged: (viewType: string) => void;
    handleChangesTypeChanged: (changeType: string, value: boolean) => void;
    handleOnClickReloadChanges: (slots: string[] | string, forceReload: boolean) => Promise<string>;
    handleEffectiveDateChanged: (validFrom: string) => void;
    handleSetChangesGeneratedDateAction: (date: string) => void;
    handleChangesLoading: () => void;
    handleChangesLoaded: () => void;
}

export const Changes = (props: ChangesStateProps & ChangesDispatchProps) => {
    const {
        handleChangesLoaded,
        handleChangesLoading,
        handleOnClickReloadChanges,
        axiosInitialized,
        slotsIds,
        handleSetChangesGeneratedDateAction,
        ticket,
        enabled,
        displayLoading,
    } = props;
    const onClickReloadChanges = useCallback(async (forceReload: boolean) => {
        try {
            handleChangesLoading();
            const restOptions = {
                slotIds: slotsIds!,
                forceReload: forceReload,
            };
            const date = await handleOnClickReloadChanges(restOptions.slotIds, restOptions.forceReload);
            handleSetChangesGeneratedDateAction(date);
        } finally {
            handleChangesLoaded();
        }
    }, []);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        if (
            (axiosInitialized && Array.isArray(slotsIds) && slotsIds.length > 0) ||
            (axiosInitialized && slotsIds === "ALL")
        ) {
            onClickReloadChanges(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [axiosInitialized, ticket]);

    if (!enabled) {
        return null;
    }

    return (
        <div className={"changesVisualizationPanel" + (displayLoading ? " loading" : "")}>
            <ChangesHeader {...props} handleReloadChanges={onClickReloadChanges} />
            <ChangesBody {...props} />
        </div>
    );
};
